import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import type { TCargoType } from 'api/swagger';
import { createStore } from './create-store';

export interface IGoalsInsightsFilter {
  date: Dayjs;
  transportLine: string;
  cargoTypes?: TCargoType[];
}

type TState = {
  filters: IGoalsInsightsFilter;
};

type TActions = {
  setFilters: (value: IGoalsInsightsFilter | undefined) => void;
  clearFilters: () => void;
};

export const useGoalsInsightsFilter = createStore<TState & TActions>(
  (set) => ({
    filters: {
      date: dayjs(),
      transportLine: '',
    },
    setFilters: (filters: IGoalsInsightsFilter | undefined) => set((state) => ({ ...state, filters })),
    clearFilters: () =>
      set((state) => ({
        ...state,
        filters: {
          date: dayjs(),
          transportLine: '',
        },
      })),
  }),
  'goals-insights-filters-store',
);
